import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import QTDetailsImageWithLabelSection from "../../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import QTDetailsAutoCompleteWithLabelSection from "../../../../../common/QTDetailsAutoCompleteWithLabelSection";
import { useContributorsContext } from "../../../../../providers/OrganizationAdmin/ContributorsProvider";
import { formatLength } from "../../../../../constants";

const AlbumDetailsDataFieldsSection = ({
  albumDetails,
  setAlbumDetails,
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
}) => {
  const { GAUsers, handleGetAllGAUsers } = useContributorsContext();
  const [usersData, setUsersData] = useState([]);
  // const { currentUser } = useAuth();

  useEffect(() => {
    if (GAUsers && GAUsers?.length > 0) {
    } else {
      handleGetAllGAUsers();
    }
  }, []);

  useEffect(() => {
    setUsersData(GAUsers);
  }, [GAUsers]);
  // console.log("sdfjh", albumDetails);
  return (
    <Grid container style={{ dataContainerStyles }}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"Album Photo"}
          image={albumDetails?.photoUrl}
          handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          editEnabled={editEnabled}
          details={albumDetails}
          setDetails={setAlbumDetails}
          uploadImage={uploadImage}
          setUploadImage={setUploadImage}
        />
        {/*ALbum Title section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Album Title"}
          value={albumDetails.title}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAlbumDetails({
              ...albumDetails,
              title: e.target.value,
            })
          }
        />
        {/*Album ID section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Album ID"}
          value={albumDetails.id}
          disabled={true}
        />
        {/*Created By section*/}
        <QTDetailsAutoCompleteWithLabelSection
          label={"Created By"}
          value={
            albumDetails?.userData != null
              ? `${albumDetails.userData.firstName} ${albumDetails.userData.lastName}`
              : albumDetails?.createdBy || ""
          }
          onChange={(docData) => {
            if (docData.id) {
              setAlbumDetails({
                ...albumDetails,
                userData: docData,
                user: docData.id,
              });
            } else {
              setAlbumDetails({
                ...albumDetails,
                userData: null,
                createdBy: docData.fullName,
                // user: albumDetails.user,
              });
            }
          }}
          disabled={true}
          optionsData={usersData}
          editEnabled={editEnabled}
        />
        {/*Creation Date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Creation Date"}
          value={
            albumDetails?.createdAt &&
            moment.unix(albumDetails?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")
          }
          disabled={true}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Description section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Album Description"}
          value={albumDetails.description}
          disabled={true}
          multiline={true}
          rows={3}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAlbumDetails({
              ...albumDetails,
              description: e.target.value,
            })
          }
        />
        {/* who Can Listen section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Who Can Listen"}
          value={editEnabled ? 
            (albumDetails.privacy ? 
              albumDetails.privacy.charAt(0).toUpperCase() + albumDetails.privacy.slice(1).toLowerCase() 
              : "") 
            : albumDetails.privacy}
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["Public", "Private", "Unlisted"]}
          onChange={(e) =>
            setAlbumDetails({
              ...albumDetails,
              privacy: e.target.value,
            })
          }
        />
        {/*# of QT in Album section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of QT in Album"}
          value={albumDetails?.quicktales?.length || 0}
          disabled={true}
        />
        {/*Length section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Length"}
          value={formatLength(albumDetails?.quicktaleData?.reduce((total, qt) => {
            const duration = parseFloat(qt?.audioLength || 0);
            return total + duration;
          }, 0) || 0)}
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default AlbumDetailsDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
